import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IContactModel } from '@apps-common/types/management/contact'

export const createContact = async (model: IContactModel): Promise<IContactModel> =>
  axios.post(`/management/contact/addcontact`, model).then((res) => res?.data?.data)

type Props = {
  model: IContactModel
}

export const useManagementCreateContact = (notify?: boolean, onSuccess?: (data: IContactModel) => void) =>
  useMutation({
    mutationKey: ['createContact'],
    mutationFn: ({ model }: Props) => createContact(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created contact.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create contact, please try again.')
      }
    },
    throwOnError: false
  })
